import { useState, type FormEvent, type KeyboardEvent } from "react";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";

// Composer: textarea 1..4000, Enter envia (Shift+Enter quebra linha). Desabilitado
// enquanto um turno roda (single-flight por conversa) ou o envio está em voo.
interface ComposerProps {
  onSend: (content: string) => void;
  busy: boolean;
  disabled: boolean;
}

export function Composer({ onSend, busy, disabled }: ComposerProps) {
  const [value, setValue] = useState("");
  const canSend = value.trim().length > 0 && !busy && !disabled;

  function submit(e: FormEvent) {
    e.preventDefault();
    if (!canSend) return;
    onSend(value.trim());
    setValue("");
  }

  function onKeyDown(e: KeyboardEvent<HTMLTextAreaElement>) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit(e);
    }
  }

  return (
    <form onSubmit={submit} className="flex items-end gap-2 border-t border-border p-3">
      <textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
        rows={1}
        maxLength={4000}
        placeholder={busy ? "Aguarde a resposta atual…" : "Pergunte sobre a operação…"}
        aria-label="Mensagem para o assistente"
        className="max-h-32 min-h-[38px] flex-1 resize-none rounded-md border border-input bg-background px-3 py-2 text-sm outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-60"
        disabled={busy || disabled}
      />
      <Button type="submit" size="icon" disabled={!canSend} aria-label="Enviar mensagem">
        <Send className="h-4 w-4" />
      </Button>
    </form>
  );
}
